import React, { useState, createElement } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon, DownloadIcon, ZoomInIcon, ZoomOutIcon, PrinterIcon } from 'lucide-react';
import { useTheme } from '../providers/ThemeProvider';
import { Navbar } from '../Navbar';
import { Footer } from '../Footer';
export const WTK1Fugue1Viewer: React.FC = () => {
  const navigate = useNavigate();
  const {
    theme
  } = useTheme();
  const isDark = theme === 'dark';
  const [zoom, setZoom] = useState(100);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const pdfUrl = 'https://firebasestorage.googleapis.com/v0/b/maestro-connect-2e3f0.firebasestorage.app/o/sheet-music%2Fbach%2Fwtk1-fugue1-a4.pdf?alt=media&token=4ef8352f-4b1f-46a6-a03d-dbc2d36167c5';
  const pdfViewUrl = isMobile ? `${pdfUrl}#view=Fit&zoom=page-width` : `${pdfUrl}#view=FitH`;
  const handleZoomIn = () => setZoom(prev => Math.min(prev + 10, 200));
  const handleZoomOut = () => setZoom(prev => Math.max(prev - 10, 50));
  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = pdfUrl;
    link.download = 'Bach - Fugue in C Major BWV 846.pdf';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const handlePrint = () => window.print();
  return <div className={`min-h-screen ${isDark ? 'bg-gradient-to-r from-[#0F1626] via-[#1E3A8A] to-[#2C3E50]' : 'bg-gray-50'}`} data-id="element-10055">
      <Navbar data-id="element-10056" />
      <div className="pt-20" data-id="element-10057">
        <div className="relative w-full" style={{
        minHeight: '320px'
      }} data-id="element-10058">
          <img src="https://images.unsplash.com/photo-1520523839897-bd0b52f945a0?w=1200&h=400&fit=crop" alt="Fugue in C Major" className="w-full h-64 md:h-80 object-cover" data-id="element-10059" />
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/30 to-black/70" data-id="element-10060" />
          <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8" data-id="element-10061">
            <div className="max-w-7xl mx-auto" data-id="element-10062">
              <button onClick={() => navigate(-1)} className="mb-4 flex items-center text-white/90 hover:text-white transition-colors" data-id="element-10063">
                <ArrowLeftIcon className="h-5 w-5 mr-2" data-id="element-10064" />
                Back to Library
              </button>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-2" data-id="element-10065">
                Fugue in C Major
              </h1>
              <p className="text-lg md:text-xl text-white/90" data-id="element-10066">
                BWV 846 · The Well-Tempered Clavier, Book I
              </p>
              <p className="text-base md:text-lg text-white/80 mt-1" data-id="element-10067">
                Johann Sebastian Bach
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className={`sticky top-20 z-10 ${isDark ? 'bg-navy-800/95 backdrop-blur-sm border-b border-white/10' : 'bg-white/95 backdrop-blur-sm border-b border-gray-200'} shadow-sm`} data-id="element-10068">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between" data-id="element-10069">
          <div className="flex items-center space-x-2" data-id="element-10070">
            {!isMobile && <>
                <button onClick={handleZoomOut} className={`p-2 rounded-lg transition-colors ${isDark ? 'hover:bg-navy-700 text-white' : 'hover:bg-gray-100 text-gray-800'}`} aria-label="Zoom out" data-id="element-10071">
                  <ZoomOutIcon className="h-5 w-5" data-id="element-10072" />
                </button>
                <span className={`text-sm font-medium px-3 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-10073">
                  {zoom}%
                </span>
                <button onClick={handleZoomIn} className={`p-2 rounded-lg transition-colors ${isDark ? 'hover:bg-navy-700 text-white' : 'hover:bg-gray-100 text-gray-800'}`} aria-label="Zoom in" data-id="element-10074">
                  <ZoomInIcon className="h-5 w-5" data-id="element-10075" />
                </button>
              </>}
          </div>
          <div className="flex items-center space-x-2" data-id="element-10076">
            <button onClick={handlePrint} className={`flex items-center justify-center px-4 py-2 rounded-lg transition-colors ${isDark ? 'hover:bg-navy-700 text-white border border-navy-700' : 'hover:bg-gray-100 text-gray-800 border border-gray-200'}`} data-id="element-10077">
              <PrinterIcon className="h-4 w-4 sm:mr-2" data-id="element-10078" />
              <span className="hidden sm:inline" data-id="element-10079">Print</span>
            </button>
            <button onClick={handleDownload} className="flex items-center justify-center px-4 py-2 border-2 border-green-500 text-green-500 bg-transparent hover:bg-green-500/10 rounded-lg transition-colors" data-id="element-10080">
              <DownloadIcon className="h-4 w-4 sm:mr-2" data-id="element-10081" />
              <span className="hidden sm:inline" data-id="element-10082">Download PDF</span>
            </button>
          </div>
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 py-8" data-id="element-10083">
        <div className={`rounded-xl overflow-hidden shadow-lg ${isDark ? 'bg-navy-800' : 'bg-white'}`} data-id="element-10084">
          <div className="w-full" style={{
          height: 'calc(100vh - 300px)',
          minHeight: '600px'
        }} data-id="element-10085">
            <iframe src={pdfViewUrl} className="w-full h-full" title="Fugue in C Major Sheet Music" style={{
            border: 'none',
            ...(isMobile ? {} : {
              transform: `scale(${zoom / 100})`,
              transformOrigin: 'top center',
              transition: 'transform 0.2s ease'
            })
          }} data-id="element-10086" />
          </div>
        </div>
        <div className={`mt-8 rounded-xl p-6 ${isDark ? 'bg-navy-800' : 'bg-white'} shadow-sm`} data-id="element-10087">
          <h2 className={`text-2xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-10088">
            About This Piece
          </h2>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-10089">
            <div data-id="element-10090">
              <h3 className={`text-lg font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-10091">
                Composition Details
              </h3>
              <dl className="space-y-2" data-id="element-10092">
                <div data-id="element-10093">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-10094">
                    Composer
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-10095">
                    Johann Sebastian Bach
                  </dd>
                </div>
                <div data-id="element-10096">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-10097">
                    Catalog
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-10098">
                    BWV 846
                  </dd>
                </div>
                <div data-id="element-10099">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-10100">
                    Key
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-10101">
                    C Major
                  </dd>
                </div>
                <div data-id="element-10102">
                  <dt className={`text-sm font-medium ${isDark ? 'text-gray-400' : 'text-gray-600'}`} data-id="element-10103">
                    Collection
                  </dt>
                  <dd className={`text-base ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-10104">
                    The Well-Tempered Clavier, Book I
                  </dd>
                </div>
              </dl>
            </div>
            <div data-id="element-10105">
              <h3 className={`text-lg font-semibold mb-2 ${isDark ? 'text-white' : 'text-gray-800'}`} data-id="element-10106">
                Performance Notes
              </h3>
              <p className={`text-sm leading-relaxed ${isDark ? 'text-gray-300' : 'text-gray-600'}`} data-id="element-10107">
                The Fugue in C Major pairs with the famous Prelude to complete
                the first entry of the Well-Tempered Clavier. A four-voice fugue
                of moderate complexity, it demonstrates Bach's mastery of
                contrapuntal writing. The subject is clear and singable, making
                it an excellent introduction to fugal analysis and performance.
                Careful attention to voice independence and articulation is
                essential to bring out the interplay between the four voices.
              </p>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-10108" />
    </div>;
};